class VideoControl extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.video = this.querySelector("video");

    this.video.addEventListener("play", () => {
      this.setAttribute("state", "playing");
    });

    this.video.addEventListener("pause", () => {
      this.setAttribute("state", "paused");
    });

    this.button = this.querySelector("[data-video-control-button]");

    const play = async () => {
      try {
        await this.video.play();
      } catch (err) {
        console.warn(err);
      }
    };

    this.button.addEventListener("click", (e) => {
      e.preventDefault();
      this.video.paused ? play() : this.video.pause();
    });
  }

  disconnectedCallback() {}
}

if (!customElements.get("video-control")) {
  customElements.define("video-control", VideoControl);
}
